// extracted by mini-css-extract-plugin
export default {"headerLeftSide":"xjyWr","headerTop":"+m4l8","linkWrapper":"UNwyW","link":"VE7F6","name":"n-5Uc","bulletSeparator":"tGpzr","timeAgo":"aSdhV","badge":"bCHDY"};